export default {
    NON_COOPERATION: null,
    PENDING: 0,
    ACTIVE: 1,
    BLOCKED: 2,
    REJECTED: 3,
    BLOCKED_AFTER_24: 4,
    STOP_BY_PUBLISHER: 5,
}